import type { BinCheckOkResponse } from '../../../models';
import { BIN_NUMBER_LENGTH } from '../constants/binVerification';

export const getBinNumber = (creditCardNumber?: string) =>
  creditCardNumber ? creditCardNumber.slice(0, BIN_NUMBER_LENGTH) : '';

export const shouldRefetchWithBinNumber = (binNumber = '', methodBinNumber?: string) =>
  Boolean(binNumber.length >= BIN_NUMBER_LENGTH && binNumber !== methodBinNumber);

const isFullBinVerification = (binVerificationType: string) =>
  Boolean(binVerificationType && binVerificationType.toLowerCase() === 'fullbin');

export const checkBinNumber = async (
  binNumber: string,
  binVerificationType: string,
  totalPrice: number,
  selectedCardTypeId?: number | null,
  isExtendedBinCheckEnabled: boolean = false,
): Promise<BinCheckOkResponse> => {
  const queryParams = new URLSearchParams();
  queryParams.append('bin', binNumber);
  queryParams.append('selectedCardId', selectedCardTypeId ? selectedCardTypeId.toString() : '');
  queryParams.append(
    'fullBinVerificationEnabled',
    isFullBinVerification(binVerificationType).toString(),
  );
  queryParams.append('orderAmount', totalPrice.toString());

  const binUrl = isExtendedBinCheckEnabled
    ? `/rpc.cart.check.bin.extended.action?${queryParams.toString()}`
    : `/rpc.cart.check.bin.action?${queryParams.toString()}`;

  return (
    await fetch(binUrl, {
      credentials: 'same-origin',
    })
  ).json();
};
